import { useSyncExternalStore } from "react"

export type Theme = "dark" | "light"

const THEME_KEY = "norn.admin.theme/1"

export function loadTheme(): Theme {
  const stored = localStorage.getItem(THEME_KEY)
  return stored === "light" ? "light" : "dark"
}

export function applyTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme
  localStorage.setItem(THEME_KEY, theme)
}

function subscribe(onChange: () => void): () => void {
  const observer = new MutationObserver(onChange)
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] })
  return () => observer.disconnect()
}

function snapshot(): Theme {
  return document.documentElement.dataset.theme === "light" ? "light" : "dark"
}

/** The active theme, re-rendering when it changes. */
export function useTheme(): Theme {
  return useSyncExternalStore(subscribe, snapshot, () => "dark")
}
